import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { List } from 'immutable';
import PanelTreeItem from './PanelTreeItem';
import Loader from '../ui/Loader';
import { isEditable } from '../../utils/piction';

function PanelTreeList({
  customIcons,
  panelTreeList,
  onPanelItemClick,
  onPanelItemDrop,
  retrievePanelTreeList,
  retrieveChildrenRequests,
  clearPanelTreeList,
  toggleCollectionCollapse,
  isRoot,
  isRetrievingRoot,
  editRequests,
  onEditSelect,
  editOptions,
  showContentCount,
  intl,
}) {
  let displayPanelTree;
  // if this is root and a retrieve is in progress only show loader when there's currently no
  // items. the scenario where items already exist is when the tree is being reloaded in which
  // case we want to leave the currently existing items displayed while the list is being reloaded
  // in the background.
  if (isRoot && isRetrievingRoot && panelTreeList.size < 1) {
    displayPanelTree = <Loader />;
  } else if (isRoot && panelTreeList.size < 1) {
    displayPanelTree = <li className="panel-list__no-items">
      {intl.formatMessage({ id: 'panelTree.noItemsMessage' })}
    </li>;
  } else {
    displayPanelTree = panelTreeList.map((item, i) => (
      <li key={i}>
        <PanelTreeItem
          retrievePanelTreeList={retrievePanelTreeList}
          retrieveChildrenRequests={retrieveChildrenRequests}
          clearPanelTreeList={clearPanelTreeList}
          toggleCollectionCollapse={toggleCollectionCollapse}
          onPanelItemClick={onPanelItemClick}
          onPanelItemDrop={onPanelItemDrop}
          id={item.get('i')}
          name={item.get('n')}
          type={item.get('t')}
          description={item.get('d')}
          search={item.get('s')}
          colour={item.get('cl')}
          hasChildren={item.get('ch') === 'TRUE'}
          panelTreeList={item.get('ct')}
          editRequests={editRequests}
          customIcons={customIcons}
          hideTreeIcon={item.get('hideIcon')}
          canEdit={isEditable(item)}
          onEditSelect={onEditSelect}
          editOptions={editOptions}
          showContentCount={showContentCount}
          contentCount={item.get('x')}
          isExpanded={item.get('xpnd')}
        />
      </li>
    ));
  }

  return (
    <div className="panel-list">
      <ul className="panel-list__list">
        {displayPanelTree}
      </ul>
    </div>
  );
}

PanelTreeList.propTypes = {
  customIcons: PropTypes.arrayOf(PropTypes.shape({
    iconClass: PropTypes.string,
    handler: PropTypes.func,
  })),
  panelTreeList: PropTypes.instanceOf(List),
  isRoot: PropTypes.bool,
  isRetrievingRoot: PropTypes.bool,
  onPanelItemClick: PropTypes.func,
  onPanelItemDrop: PropTypes.func,
  retrievePanelTreeList: PropTypes.func,
  retrieveChildrenRequests: PropTypes.shape({}),
  clearPanelTreeList: PropTypes.func,
  toggleCollectionCollapse: PropTypes.func,
  editRequests: PropTypes.shape({}), // has dynamic props
  canEdit: PropTypes.bool,
  onEditSelect: PropTypes.func,
  showContentCount: PropTypes.bool,
  editOptions: PropTypes.arrayOf(PropTypes.shape({
    eventKey: PropTypes.string,
    label: PropTypes.string,
  })),
};

export default injectIntl(PanelTreeList);



// WEBPACK FOOTER //
// ./src/js/components/PanelTree/index.jsx